"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoPlyr = void 0;
const plyr_1 = __importDefault(require("plyr"));
class VideoPlyr {
    static initPlyr() {
        const player = new plyr_1.default('.js-player');
        player.on('ready', function () {
            player.volume = 0;
            player.play();
        });
    }
}
exports.VideoPlyr = VideoPlyr;
